import { GIFT_CARDS_SET } from '@ecomm/data-constants'
import type { Product } from '@ecomm/tracking-types/Ecommerce'

/**
 * Util function for returning a gift card product (if it exists)
 * from a list of Braze products. Gift card product can be either a Visa
 * gift card, Amazon gift card, or an object with an empty name and SKU.
 */
export const getBrazeGiftCardProduct = (products: readonly Product[]) => {
  const product = products.find(product => GIFT_CARDS_SET.has(product.id || ''))

  const visaGiftCard = {
    giftName: product?.name ?? '',
    giftSku: product?.id ?? ''
  }

  return visaGiftCard
}
